export const updateDraggableList = (list, startIndex, endIndex, onChange, sessionId) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    onChange(result, sessionId);
};